import { Component, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule, AbstractControl, FormArray, } from '@angular/forms';
// import {
//   BsDaterangepickerInlineDirective,
//   BsDatepickerInputDirective,
//   BsDatepickerDirective,
// } from 'ngx-bootstrap/datepicker';
import {
  NgSelectComponent,
  NgOptionComponent,
  NgOptgroupTemplateDirective,
} from '@ng-select/ng-select';
import { BsDatepickerDayDecoratorComponent } from "ngx-bootstrap/datepicker/themes/bs/bs-datepicker-day-decorator.directive";
import { ProfileService } from 'src/app/services/api/consumer/profile.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { SchoolData } from 'src/app/models/schoolUser';
import { DirectivesModule } from 'src/app/directives.module';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SubjectChipsComponent } from 'src/app/shared-module/subject-chips/subject-chips.component';
import Intercom from '@intercom/messenger-js-sdk';


@Component({
  selector: 'app-qld-profile-completion',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule, NgSelectComponent, DatePipe, DirectivesModule, NgbTooltip, SubjectChipsComponent],
  templateUrl: './qld-profile-completion.component.html',
  styleUrl: '../profile.component.scss',
})
export class QldProfileCompletionComponent implements OnInit {

  constructor(private ngxService: NgxUiLoaderService,
    private toastr: ToastrService, private modalService: BsModalService, public bsModalRef: BsModalRef, private fb: FormBuilder, private ProfileService: ProfileService, private router: Router) { }

  @ViewChild('qldProfileCompletionModal') qldProfileCompletionModal: any;
  @ViewChild('successProfileCompletionModal') successProfileCompletionModal: any;
  @ViewChild('deactivateSuccessModal') deactivateSuccessModal: any;
  @ViewChild('QLDDeactivationConfirmationModal') QLDDeactivationConfirmationModal: any;

  // @Input() subjects!: any[];
  // @Input() teachingLevels!: any[];
  @Input() profileData!: any;
  @Input() from!: any;
  @Input() action !: any;
  public schoolProps!: SchoolData;

  @Output() trigger = new EventEmitter<string>();


  qldProfileForm!: FormGroup;
  step = 1;
  availableStates: any;
  disableEmployeeForm: boolean = true;
  disableContactForm: boolean = true;
  qldData: any;
  subjects: any;
  teachingLevels: any;
  userRole: string = '';
  typeOfDeleteAction: string = '';
  selectedQualifiedSub: any[] = [];
  filteredSubjects: any[] = [];

  ngOnInit(): void {
    this.formInitialization();
    this.userRole = localStorage.getItem('userRole') || '';
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
  }

  ngOnChanges() {
    console.log(this.profileData);

    this.qldData = this.profileData?.user_data?.qld_data;

    this.teachingLevels = this.profileData?.preferred_year_level;
    this.subjects = this.profileData?.subject;
    this.filteredSubjects = this.profileData?.subject;

    if (this.action === 'OPEN_Qld_PROFILE') {
      this.qldProfileCompletionmodel();
    }
  }

  createDisabledControl(value: any = '') {
    return this.fb.control({ value, disabled: true });
  }
  createControl(value: any = '', disabled: boolean = false) {
    return this.fb.control({ value, disabled });
  }
  createControlWithValidation(value: any = '', disabled: boolean = false) {
    if (value === 'phone') {
      return this.fb.control(
        { value, disabled },
        [
          Validators.pattern(/^[\d+\s]+$/) // Only digits, +, and spaces allowed
        ]
      );
    }
    return this.fb.control({ value, disabled }, Validators.required);
  }


  formInitialization() {
    this.qldProfileForm = this.fb.group({
      employeeDetails: this.fb.group({
        legal_name: this.createDisabledControl(),
        legal_first_name: this.createDisabledControl(),
        legal_last_name: this.createDisabledControl(),
        employee_id: this.createDisabledControl(),
        dob: this.createDisabledControl(),
        work_eligibility: this.createDisabledControl(),
        visa_expiry_date: this.createDisabledControl(),
        qct_number: this.createDisabledControl(),
        qct_evidence: this.createDisabledControl(),
        qct_annual_fee_due: this.createDisabledControl(),
        all_staff_training: this.createDisabledControl(),
        student_protection: this.createDisabledControl(),
        cara: this.createDisabledControl(),
        mandatory_training: this.createDisabledControl(),
        relief_role: this.createDisabledControl()
      }),

      contactDetails: this.fb.group({
        preferred_first_name: this.createDisabledControl(),
        preferred_last_name: this.createDisabledControl(),
        previous_last_name: this.createControl(),
        gender: this.createDisabledControl(),
        country: this.createDisabledControl(),
        state: this.createDisabledControl(),
        street_number: this.createDisabledControl(),
        street_name: this.createDisabledControl(),
        suburb: this.createDisabledControl(),
        postcode: this.createDisabledControl(),
        mobile_number: this.createDisabledControl(),
        secondary_phone_number: this.createControl(),
        email_address: this.createDisabledControl(),
        emergency_contact_name1: this.createControlWithValidation(),
        emergency_contact_phone1: this.createControlWithValidation('phone'),
        emergency_contact_relation1: this.createControlWithValidation(),
        emergency_contact_name2: this.createControlWithValidation(),
        emergency_contact_phone2: this.createControlWithValidation('phone'),
        emergency_contact_relation2: this.createControlWithValidation()
      }),


      subjectsAndLevels: this.fb.group({
        subjects: this.fb.control([], Validators.required),
        levels: this.fb.control([], Validators.required)
      })
    });


  }


  qldProfileCompletionmodel() {
    let releifRoleValue = this.qldData?.employee_details?.reliefRole == 'N' ? 'Normal' : this.qldData?.employee_details?.reliefRole == 'T' ? 'Temp' : this.qldData?.employee_details?.reliefRole == 'B' ? 'Both LRT/DRT' : this.qldData?.employee_details?.reliefRole == 'L' ? 'LRT' : this.qldData?.employee_details?.reliefRole == 'D' ? 'DRT' : '';
    this.qldProfileForm.get('employeeDetails')?.patchValue({
      legal_name: this.qldData?.legal_name || '',
      legal_first_name: this.qldData?.first_name || '',
      legal_last_name: this.qldData?.last_name || '',
      employee_id: this.qldData?.employee_id || '',
      dob: this.qldData?.dob ? new DatePipe('en-US').transform(
        this.qldData?.dob,
        'dd/MM/YYYY'
      ) : '',
      work_eligibility: this.qldData?.employee_details?.work_eligibility || '',
      visa_expiry_date: this.qldData?.employee_details?.visa_expiry_date || '',
      qct_number: this.qldData?.qct_number || '',
      qct_evidence: this.qldData?.employee_details?.qct_evidence || '',
      qct_annual_fee_due: this.qldData?.employee_details?.qct_annual_fee_due || '',
      all_staff_training: this.qldData?.employee_details?.all_staff_training || '',
      student_protection: this.qldData?.employee_details?.student_protection || '',
      cara: this.qldData?.employee_details?.cara || '',
      mandatory_training: this.qldData?.employee_details?.mandatory_training || '',
      relief_role: releifRoleValue || ''
    });

    this.qldProfileForm.get('contactDetails')?.patchValue({
      preferred_first_name: this.profileData?.user_data?.user.first_name || '',
      preferred_last_name: this.profileData?.user_data?.user.last_name || '',
      previous_last_name: this.qldData?.employee_details?.previous_last_name || '',
      gender: this.profileData?.user_data?.meta?.gender || '',
      country: this.profileData?.user_data?.address?.address_timezone?.country || '',
      state: this.profileData?.user_data?.address?.address_timezone?.state || '',
      street_number: this.profileData?.user_data?.address?.locality || '',
      street_name: this.profileData?.user_data?.address?.street || '',
      suburb: this.profileData?.user_data?.address?.city || '',
      postcode: this.profileData?.user_data?.address?.postal_code || '',
      mobile_number: this.profileData?.user_data?.phone || '',
      secondary_phone_number: this.profileData?.user_data?.meta?.emergency_contact?.secondary_phone_number || '',
      email_address: this.profileData?.user_data?.user?.email || '',
      emergency_contact_name1: this.profileData?.user_data?.meta?.emergency_contact?.emergency_contact_name1 || '',
      emergency_contact_phone1: this.profileData?.user_data?.meta?.emergency_contact?.emergency_contact_phone1 || '',
      emergency_contact_name2: this.profileData?.user_data?.meta?.emergency_contact?.emergency_contact_name2 || '',
      emergency_contact_phone2: this.profileData?.user_data?.meta?.emergency_contact?.emergency_contact_phone2 || '',
      emergency_contact_relation1: this.profileData?.user_data?.meta?.emergency_contact?.emergency_contact_relation1 || '',
      emergency_contact_relation2: this.profileData?.user_data?.meta?.emergency_contact?.emergency_contact_relation2 || '',
    });

    const mergedSubjects = [
      ...(this.qldData?.subject?.selected_qualified || []),
      ...(this.qldData?.subject?.selected_unknown || [])
    ];
    this.selectedQualifiedSub = mergedSubjects;
    this.qldProfileForm.get('subjectsAndLevels')?.patchValue({
      subjects: mergedSubjects,
      levels: this.qldData?.level?.selected_level || []
    });

    // console.log(this.qldData?.subject?.selected_subject);
    this.bsModalRef = this.modalService.show(this.qldProfileCompletionModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }

  filterSubjects(event: any) {
    const search = event.target.value.toLowerCase();
    this.filteredSubjects = this.profileData?.subject?.filter((s: any) =>
      s.toLowerCase().includes(search)
    );
  }

  isSelected(school: any): boolean {
    return this.selectedQualifiedSub.some((s: any) => s === school);
  }

  toggleSelection(school: any) {

    const index = this.selectedQualifiedSub.findIndex(s => s === school);
    if (index > -1) {
      this.selectedQualifiedSub.splice(index, 1);
    } else {
      this.selectedQualifiedSub.push(school);
    }
    this.qldProfileForm.get('subjectsAndLevels')?.patchValue({
      subjects: this.selectedQualifiedSub
    });

  }

  removeSchool(school: any) {
    const index = this.selectedQualifiedSub.findIndex(s => s === school);
    this.filteredSubjects = this.filteredSubjects.filter(id => id !== school);
    if (index > -1) {
      this.selectedQualifiedSub.splice(index, 1);
    }
    this.qldProfileForm.get('subjectsAndLevels')?.patchValue({
      subjects: this.selectedQualifiedSub
    });
  }

  submitQLDForm() {
    this.ngxService.start();
    // if (this.qldProfileForm.invalid) {
    //   // Mark all controls as touched to show validation errors
    //   this.qldProfileForm.markAllAsTouched();
    //   this.ngxService.stop();
    //   return;
    // }
    // console.log(this.qldProfileForm.value);
    // this.bsModalRef.hide();
    // Submit the form data to the server or perform any other actions
    this.ProfileService.submitQLDProfile(this.qldProfileForm.value).subscribe(
      (response) => {
        if (response.status) {
          this.bsModalRef.hide();
          if (this.profileData?.user_data?.qld_data?.role_type != 'LRT' && this.profileData?.user_data?.qld_data?.role_type != 'DRT' && localStorage.getItem('qldProfileCompleted') != 'true') {
            localStorage.setItem('qldProfileCompleted', 'true');
            this.intercomValues()
            setTimeout(() => {
              this.bsModalRef = this.modalService.show(this.successProfileCompletionModal, {
                class: 'modal-md',
                backdrop: 'static',
              });
            }, 1000);
          } else {
            this.toastr.success(response.message || 'Profile updated successfully');
          }
          this.sendEvent();
          this.action = '';
          // Optionally, show a success message or perform other actions
          this.ngxService.stop();
          this.step = 1;
        } else {
          this.toastr.error(response.message || 'Error updating profile');
          this.ngxService.stop();
        }
      },
      (error) => {
        console.error('Error submitting form', error);
        // Optionally, show an error message or perform other actions
      }
    );
  }
  intercomValues() {
    const intercomClient = (window as any).Intercom;
    if (typeof intercomClient !== 'function') {
      return;
    }
    intercomClient('update', {
      is_qld_user: true,
      "is qld_doe_user": true,
      is_qld_doe_user: true,
      is_qld_doe_relief_teacher: true
    });
  }
  goToStep(stepNumber: number) {
    // let currentGroup: FormGroup | null = null;
    // if (this.step === 1) {
    //   currentGroup = this.qldProfileForm.get('employeeDetails') as FormGroup;
    // } else if (this.step === 2) {
    //   currentGroup = this.qldProfileForm.get('contactDetails') as FormGroup;
    // } else if (this.step === 3) {
    //   currentGroup = this.qldProfileForm.get('subjectsAndLevels') as FormGroup;
    // }

    // if (stepNumber == 3) {
    //   console.log(this.qldProfileForm.get('contactDetails.emergency_contact_name1')?.value);
    // }

    // let hasRequiredError = false;
    // if (currentGroup) {
    //   Object.keys(currentGroup.controls).forEach(key => {
    //     const control = currentGroup?.get(key);
    //     const validators = control?.validator ? control.validator({} as AbstractControl) : null;
    //     const isRequired = validators && validators['required'];
    //     if (isRequired && control?.invalid) {
    //       control.markAsTouched();
    //       hasRequiredError = true;
    //     }
    //   });
    // }

    // if (hasRequiredError) {
    //   return; // Prevent navigation if any required field is invalid
    // }

    this.step = stepNumber;
  }

  // Simple helper to check error visibility
  isInvalid(formGroup: string, controlName: string): boolean {
    const group = this.qldProfileForm.get(`${formGroup}`);
    const control = group ? group.get(controlName) : null;
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  sendEvent() {
    this.trigger.emit('refresh_parent!');
  }

  navigateToFindSchools() {
    this.bsModalRef.hide();
    this.router.navigate(['/teacher/find-new-schools']);
  }

  trainingMap: any = {
    mandatoryTrainingStudentProtection: 'Mandatory training - Student Protection',
    mandatoryTrainingAllStaff: 'Mandatory training - All-Staff Training',
    mandatoryTrainingCARA: 'Mandatory training - CARA',
  };

  reactivateQLDAccount() {
    this.bsModalRef.hide();
    this.ngxService.start();
    let teacher_id = {
      teacher_id: this.profileData?.user_data?.qld_data?.id
    }
    this.ProfileService.reactivateQLDAccount(teacher_id).subscribe({
      next: (response) => {
        if (response.status) {
          // this.typeOfDeleteAction = 'delete-only';
          this.ngxService.stop();
          this.bsModalRef.hide();
          this.typeOfDeleteAction = 'reactivate-only';
          this.bsModalRef = this.modalService.show(this.deactivateSuccessModal, {
            class: 'modal-md',
            backdrop: 'static',
          });
        } else {
          this.toastr.error(response.message || 'Error deactivating account');
          this.ngxService.stop();
        }
      },
      error: (error) => {
        this.toastr.error(error?.error?.message || 'Something went wrong while deleting account');
        this.ngxService.stop();
      },
      complete: () => {
        // Optional cleanup logic if needed
      }
    });

  }

  deactivateQLDAccount() {
    this.bsModalRef.hide();
    this.ngxService.start();
    let teacher_id = {
      teacher_id: this.profileData?.user_data?.qld_data?.id
    }
    this.ProfileService.deactivateQLDAccount(teacher_id).subscribe({
      next: (response) => {
        if (response.status) {
          this.ngxService.stop();
          this.typeOfDeleteAction = 'deactivate-only';
          this.bsModalRef = this.modalService.show(this.deactivateSuccessModal, {
            class: 'modal-md',
            backdrop: 'static',
          });
        } else {
          if (response?.is_upcoming_booking) {
            this.typeOfDeleteAction = 'future-deactivate';
            this.bsModalRef = this.modalService.show(this.deactivateSuccessModal, {
              class: 'modal-md',
              backdrop: 'static',
            });
          } else {
            this.toastr.error(response.message || 'Error deactivating account');
          }
          this.ngxService.stop();
        }
      },
      error: (error) => {
        this.toastr.error(error?.error?.message || 'Something went wrong while deactivating account');
        this.ngxService.stop();
      },
      complete: () => {
        // Optional cleanup logic if needed
      }
    });
  }

  refreshPage() {
    if (this.typeOfDeleteAction != 'future-deactivate' && this.typeOfDeleteAction != 'future-delete') {
      let currentUrl = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }
  }

  openDeactivateConfirmModal() {
    this.bsModalRef = this.modalService.show(this.QLDDeactivationConfirmationModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  reactivateQLDAccountInfo() {
    this.bsModalRef.hide();
    this.toastr.warning('Please wait 30 minutes after deactivation before reactivating your account');
    setTimeout(() => {
      this.refreshPage();
    }, 300);
  }

}
